import React from "react";
import useUser from "../hooks/useUser";
import NavHeader from "./NavHeader";

export default function Header() {
  const { user } = useUser();

  return <NavHeader user={user} notificationCount={0} messageCount={0} />;
}
